import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";
import "./themes/default.css";

import App from './components/App';
import * as serviceWorker from './serviceWorker';
import "./FontAwesomeLibrary";
import "./index.css";

import Lore from "lore-engine";
import transparentSmoothCircle from "./shaders/transparentSmoothCircle";

Lore.Shaders.transparentSmoothCircle = transparentSmoothCircle;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
